/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { isEmpty } from 'lodash';

// Components
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';

const __vue_script__ = {
    name: 'AffectedUsers',

    components: { SearchBar },

    props: {
        count: {
            type: Number,
            default: 0,
        },
        users: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            searchTerm: ''
        };
    },

    computed: {
        // Note that this behaviour can be improved as described here https://spotme.atlassian.net/browse/EP-15315
        tooManyTargetedUsers() {
            return this.count > this.users.length;
        },

        filteredUsers() {
            return this.users.filter(u => {
                const name = `${u.fname} ${u.lname}`.toLocaleLowerCase();
                return isEmpty(this.searchTerm) || name.includes(this.searchTerm.toLocaleLowerCase());
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"affected-users modal-wrapper"},[_c('div',{staticClass:"modal-header"},[_c('a',{staticClass:"close",attrs:{"aria-label":_vm.$t('general.close')},on:{"click":function($event){return _vm.$emit('close')}}}),_c('h2',[_vm._v(_vm._s(_vm.$t('targeting.conditions_editor.affected_pax_title', [_vm.count])))])]),_c('div',{staticClass:"modal-body"},[_c('search-bar',{attrs:{"results":_vm.filteredUsers,"show-no-result":false},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),(_vm.tooManyTargetedUsers)?_c('span',[_vm._v(_vm._s(_vm.$t('targeting.too_many_pax')))]):_vm._e(),_c('div',{staticClass:"table-wrapper"},[_c('table',{staticClass:"table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('targeting.conditions_editor.pax_name')))])])]),_c('tbody',_vm._l((_vm.filteredUsers),function(user){return _c('tr',[_c('td',[_vm._v(_vm._s(user.fname)+" "+_vm._s(user.lname))])])}),0)])])],1),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(_vm._s(_vm.$t('general.close')))])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "AffectedUsers.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__